import React, {useEffect, useState} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    withStyles,
    Typography,
    FormControl, InputLabel, OutlinedInput, IconButton, Tooltip
} from '@material-ui/core';
import {mobileIcon, remoteIcon, workIcon, mobileCheckIcon, mobileDiagnoseIcon, mobileErasureLiteIcon, mobileVerifierIcon, workCheckIcon, workDiagnoseIcon, workVerifierIcon, moneyIcon, watchIcon, watchDiagnoseIcon, watchCheckIcon, headphoneDiagnoseIcon, headphoneCheckIcon} from "../../sc-accountManagement/PrepaidBalance/utils";
import {Info} from "@material-ui/icons";
import {
    fetchPrepaidBalance,
} from "../../sc-accountManagement/PrepaidBalance/store/prepaidBalanceActions";
import {connect} from "react-redux";
import {getUnitNameTranslation} from "../../sc-users/User/UserDetails/UserEdit";

const styles = theme => ({
    licenseType: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(),
    },
    unitName: {
        marginRight: theme.spacing(),
        width: '22rem',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '0 auto',
        width: 'auto',
        padding: theme.spacing(),
    },
    title: {
        display: "flex",
    },
    icon: {
        color: 'rgb(220,220,220)',
    },
    disabledInput: {
        marginRight: theme.spacing(),
    },
    amountDifference: {
        marginLeft: theme.spacing(),
        width: theme.spacing(10),
        textAlign: "center",
    },
});

const LicenseEditModal = (props) => {
    const { classes, handleClose, handleSave, translations, modalState, balances=[], onBalanceList, activeCustomerID, currentBalances, group, user } = props;

    const [accountBalances, setAccountBalances] = useState([]);

    const getBalancesObject = (balancesList) => {
        if (balancesList && balancesList.length>0) {
            return balancesList.reduce((acc, balance) => {
                acc[balance.Unit] = balance.Unit==="currency"? balance.Credits : Number(balance.Credits);
                return acc;
            }, {});
        } return [];
    }

    const getAmountDifference = (currentTypeValue, licenseTypeValue) => {
        let difference = 0;
        if (currentTypeValue>licenseTypeValue) {
            difference = `-${(currentTypeValue-licenseTypeValue)}`;
        } else if (currentTypeValue<licenseTypeValue) {
            difference = `+${(licenseTypeValue-currentTypeValue)}`;
        } else if (!currentTypeValue && licenseTypeValue) {
            difference = `+${licenseTypeValue}`;
        }
        return difference;
    }

    const [licenses, setLicenses] = useState(getBalancesObject(balances));
    const currentBalancesObject = getBalancesObject(currentBalances);

    useEffect(() => {
        setLicenses(getBalancesObject(balances));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [balances, modalState]);

    useEffect(() => {
        const getAccountBalances = async () => {
            const params = { ActiveCustomerID: activeCustomerID };
            if (group) {
                params["GetFromParent"] = true;
                params["GroupID"] = group?.GroupID;
            } else if (user?.UserGroups && user?.UserGroups?.length>0) {
                params["GetFromParent"] = true;
                params["GroupID"] = user?.UserGroups[0]?.GroupID;
                params["ForIndividual"] = true;
            }
            const result = await onBalanceList(params);
            if (result) {
                setAccountBalances(result);
            }
        }
        if (modalState?.open) {
            setAccountBalances(getAccountBalances());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCustomerID, modalState]);

    const accountBalancesTooltipContent = <Typography variant="subtitle1">
        {accountBalances?.length>0 && accountBalances?.map((balance) => <React.Fragment key={balance.Unit}><span>{getUnitNameTranslation(balance.Unit, translations)}: {balance.Unit==="currency"? balance.Credits : Number(balance.Credits)}</span><br/></React.Fragment>)}
    </Typography>

    const saveAndCloseModal = () => {
        const updatedBalances = Object.keys(licenses).map((key) => {return {Unit: key, Credits: licenses[key]}});
        handleSave(updatedBalances)
    }

    const handleCancel = () => {
        handleClose();
    }

    const balanceType = (type) => {
        const icon = type === "remote" ? remoteIcon : type === "mobile" ? mobileIcon : type === "mobile_erasure_lite" ? mobileErasureLiteIcon : type === "mobile_verifier" ? mobileVerifierIcon : type === "mobile_diagnose" ? mobileDiagnoseIcon : type === "mobile_check" ? mobileCheckIcon : type === "work" ? workIcon : type === "work_verifier" ? workVerifierIcon : type === "work_diagnose" ? workDiagnoseIcon : type === "work_check" ? workCheckIcon : type === "currency" ? moneyIcon : type === "watch" ? watchIcon : type === "watch_diagnose" ? watchDiagnoseIcon : type === "watch_check" ? watchCheckIcon : type === "headphone_diagnose" ? headphoneDiagnoseIcon : type === "headphone_check" ? headphoneCheckIcon : null
        const blockInvalidChar = (e) => type==="currency"? ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault() : ['e', 'E', '+', '.', '-'].includes(e.key) && e.preventDefault();

        const differenceInAmount = getAmountDifference(currentBalancesObject[type], licenses[type]);

        return <div className={classes.row}>
            <Typography variant="h6" className={classes.unitName}>
                {icon} {getUnitNameTranslation(type, translations)}
            </Typography>
            <FormControl variant="outlined" className={classes.disabledInput}>
                <InputLabel>{translations['current_amount'] || 'Current amount'}</InputLabel>
                <OutlinedInput
                    name={type}
                    label={translations['current_amount'] || 'Current amount'}
                    type="number"
                    value={currentBalancesObject[type] || 0}
                    inputProps={{
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                            min: 0
                        },
                        min: "0"
                    }}
                    disabled
                />
            </FormControl>
            <FormControl variant="outlined">
                <InputLabel htmlFor="license_amount">{translations['license_amount'] || 'License amount'}</InputLabel>
                <OutlinedInput
                    name={type}
                    label={translations['license_amount'] || 'License amount'}
                    type="number"
                    onKeyDown={(e) => {blockInvalidChar(e);}}
                    value={licenses[type] || 0}
                    onChange={(e) => {setLicenses(prevState => { return {...prevState, [type]: Number(e.target.value)} })}}
                    inputProps={{
                        autoComplete: 'new-password',
                        form: {
                            autoComplete: 'off',
                            min: 0
                        },
                        min: "0"
                    }}
                    labelWidth={0}
                />
            </FormControl>

            <Typography variant="subtitle2" className={classes.amountDifference}>Difference<br/>
            {(differenceInAmount || differenceInAmount===0)? differenceInAmount : licenses[type]}</Typography>
        </div>
    }

    const availableLicensesTooltip = <Tooltip title={accountBalances && Object.keys(accountBalances).length>0? accountBalancesTooltipContent : (translations["no_licenses"] || "No licenses")}>
        <IconButton aria-haspopup="true" color="inherit">
            <Info className={classes.icon} />
        </IconButton>
    </Tooltip>

    return (
        <Dialog
            open={modalState.open}
            onClose={handleCancel}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
            maxWidth="md"
        >
            <div className={classes.title}>
                <DialogTitle>{translations['assigned_licenses'] || "Assigned licenses"}</DialogTitle>
                {availableLicensesTooltip}
                </div>
            <DialogContent>
                {balanceType("work")}
                {balanceType("work_verifier")}
                {balanceType("work_diagnose")}
                {balanceType("work_check")}
                {balanceType("mobile")}
                {balanceType("mobile_erasure_lite")}
                {balanceType("mobile_verifier")}
                {balanceType("mobile_diagnose")}
                {balanceType("mobile_check")}
                {balanceType("remote")}
                {balanceType("currency")}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} variant="contained">
                    {translations['cancel'] || 'Cancel'}
                </Button>
                <Button onClick={saveAndCloseModal} variant="contained" color={"primary"}>
                    {translations['save'] || 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onBalanceList: params => dispatch(fetchPrepaidBalance(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(LicenseEditModal));